import React from 'react';
import { FaLongArrowAltDown, FaLongArrowAltUp } from 'react-icons/fa';

const SortIcons = ({ direction }) => (
  <div style={{ display: 'flex' }}>
    <FaLongArrowAltDown opacity={direction === 'ascending' ? 1 : 0.5} />
    <FaLongArrowAltUp
      opacity={direction === 'descending' ? 1 : 0.5}
      style={{ marginLeft: '-5px' }}
    />
  </div>
);

export { SortIcons };
